import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { TabNavigationComponent } from './tab-navigation.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PermissionModule } from "libraries/permission/permission.module";
import { PriceSwitcherComponent } from "libraries/component/tab-navigation/price-switcher.component";

@NgModule({
  imports: [
      CommonModule,
      RouterModule,
      MatTooltipModule,
      PermissionModule,
    ],
  declarations: [
      TabNavigationComponent,
      PriceSwitcherComponent,
  ],
  exports: [
      TabNavigationComponent,
      PriceSwitcherComponent,
  ]
})
export class TabNavigationModule { }
